// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__3RZ6b","anima":"Alert_anima__J+kLe"};